<template>
<div ref="modal" class="c-m-modal" tabindex="0" @keyup.esc="close" @click="isClickOutside">
    <div class="c-m-modal__inner" :class="{ 'c-m-modal-carousal__center-content': centerContent}" @keyup.esc="close">
        <button v-if="!hideCloseButton" class="c-m-modal__close" type="button" @click="close" aria-label="Stäng modal">
            <icon :icon="'close'"></icon>
        </button>
        <slot></slot>
    </div>
</div>
</template>

<script>
import Icon from '../atoms/AtomIcon.vue';

export default {
    props: ['hideCloseButton', 'centerContent'],
    components: {
        Icon
    },
    methods: {
        close() {
            this.$emit('close');
        },
        isClickOutside(event) {
            if (event.target === this.$refs.modal) {
                this.close();
            }
        }
    },
    mounted() {
        this.$refs.modal.focus();
    }
}
</script>



// WEBPACK FOOTER //
// src/views/components/molecules/MoleculeModal.vue